export default __webpack_public_path__ + "static/media/phoneIcon_profile.5d77e377.svg";